module.exports = __webpack_public_path__ + "on_ramp_slight_left.svg?d9dc2dbc16d6e4276fa4bddf240f025b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/on_ramp_slight_left.svg
// module id = 204
// module chunks = 0